module.exports = __webpack_public_path__ + "static/models/car_body.2b61f23.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/car/car_body.json
// module id = 581
// module chunks = 1